import {call, put, takeLatest} from 'redux-saga/effects'

import * as showroomsSearchActions from '../../actions/showrooms/search'
import * as report from '../../report'
import {getShowroomLocations} from '../../api/showrooms'
import {onStatus} from '../../api/api'
import {LocationsSearchError} from '../../exceptions'

/**
 * Handles fetching showroom locations by zip code and distance.
 *
 * @param {Object} payload
 * @param {String} payload.zip The zip code
 * @param {Number} payload.distance The distance selected
 */
export function* getLocationsByZipRadiusWorker({payload: {zip, distance}}) {
  yield put(showroomsSearchActions.getLocationsByZipRadiusPending())

  try {
    const response = yield call(getShowroomLocations, zip, distance)
    const locations = onStatus({
      OK: ({json}) => json,
      400: () => {
        throw new LocationsSearchError({isBadRequest: true})
      },
      DEFAULT: () => {
        throw new LocationsSearchError({isBadRequest: false})
      },
    })(response)

    yield put(showroomsSearchActions.getLocationsByZipRadiusSuccess(locations))
  } catch (e) {
    report.exception(e)
    yield put(showroomsSearchActions.getLocationsByZipRadiusFailure(e))
  }
}

export function* getLocationsByZipRadiusSaga() {
  yield takeLatest(
    showroomsSearchActions.GET_LOCATIONS_BY_ZIP_RADIUS,
    getLocationsByZipRadiusWorker,
  )
}
